var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{ref:"sitesways",attrs:{"hide-org-badge":"","table-ref":"site_ways","title":"Sites Ways","icon":"fa fa-sort-numeric-up","url":"/view/sites/ways","trackBy":"ways","sortField":"ways","fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }